<template>
  <div>
    <h4 class="mb-2 ml-2" style="font-size: 16px">
      Diagnosis Codes
    </h4>
    <div class="d-flex flex-column mb-2 border-top">
      <span
        v-for="diagnosisCode in diagnosisCodes"
        :key="diagnosisCode.id"
        class="diagnosis-code"
      >
        <b-badge variant="primary" class="text-white mr-1 p-1"
          >{{ diagnosisCode.category[0] }}
        </b-badge>
        <strong>{{ diagnosisCode.icdCode.code }}</strong> -
        {{ diagnosisCode.icdCode.description }} ({{
          formatDates(diagnosisCode)
        }})
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import diagnosisCodeServer from "../../server/diagnosisCode";

export default {
  name: "EocViewSummaryDiagnosisCodes",
  props: ["eoc"],
  data() {
    return {
      diagnosisCodes: []
    };
  },
  mounted() {
    this.fetchDiagnosisCodes();
  },
  methods: {
    async fetchDiagnosisCodes() {
      const diagnosisCodes = await diagnosisCodeServer.query(
        false,
        this.eoc.id
      );

      this.diagnosisCodes = diagnosisCodes
        .filter(u => u.status.name == "Active" || u.status.name == "Resolved")
        .sort((a, b) => {
          return a.category < b.category ? -1 : a.category > b.category ? 1 : 0;
        });

      this.$emit("shouldDisplay", !!this.diagnosisCodes.length);
    },
    formatDates(diagnosisCode) {
      const startDate = moment(diagnosisCode.activeFrom).format("MMM D");
      const endDate = diagnosisCode.resolvedBy
        ? moment(diagnosisCode.resolvedBy).format("MMM D")
        : "Unspecified";
      return `${startDate} - ${endDate}`;
    }
  }
};
</script>

<style>
.diagnosis-code {
  font-size: 14px;
  padding: 8px;
}
.diagnosis-code:last-of-type {
  padding-bottom: 0;
}
</style>
